export default __webpack_public_path__ + "static/media/3.1ae6b098.jpg";